/**
 * Check a feature flag from environment variables
 * 
 * @param flagName - The name of the environment variable (e.g., 'VITE_PAGE_LISTING_WITH_BUILDER')
 * @returns Boolean indicating if the feature is enabled
 * 
 * @example
 * const isBuilderEnabled = checkFeatureFlag('VITE_PAGE_LISTING_WITH_BUILDER');
 * // Or use directly in template:
 * // v-if="checkFeatureFlag('VITE_PAGE_LISTING_WITH_BUILDER')"
 */
export function checkFeatureFlag(flagName) {
    const envKey = `${flagName}`;
    //@ts-ignore - Vite environment variables
    const value = import.meta.env[envKey];
    
    // Handle string 'true'/'false' or boolean values
    if (typeof value === 'string') {
        return value.toLowerCase() === 'true';
    }
    
    return Boolean(value);
}

